import React from 'react';

const PizzaEmoji = () => {
  return (
    <svg
      width="26"
      height="32"
      viewBox="0 0 26 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 3.46667C19.2894 3.46667 24.2667 6.93333 25.7391 5.2C25.9099 4.92007 26 4.6306 26 4.33333C26 2.6 20.1795 0 13 0C5.82053 0 0 2.6 0 4.33333C0 4.6306 0.0901334 4.92007 0.260867 5.2C1.73333 6.93333 6.7106 3.46667 13 3.46667Z"
        fill="#F4900C"
      />
      <path
        d="M13 2.60001C7.6154 2.60001 3.79947 4.16867 2.3634 4.86894C1.95 5.07087 1.89627 5.59694 2.00373 5.97654C2.1112 6.35614 11.2667 29.4667 11.2667 29.4667C11.2667 29.4667 12.0432 31.2 13 31.2C13.9568 31.2 14.7333 29.4667 14.7333 29.4667L24.0101 5.87514C24.0101 5.87514 24.1947 5.14541 23.517 4.81001C22.0064 4.06381 18.2407 2.60001 13 2.60001Z"
        fill="#FFCC4D"
      />
      <path
        d="M13 26.8667C13 24.9531 11.4478 23.4 9.53333 23.4C9.3132 23.4 9.1 23.4251 8.89113 23.465L11.2667 29.4667C11.2667 29.4667 11.3282 29.588 11.4313 29.7631C12.3751 29.1434 13 28.0791 13 26.8667ZM12.1333 17.3333C12.1333 15.4189 10.5803 13.8667 8.66666 13.8667C7.4308 13.8667 6.35266 14.5184 5.73906 15.4925L7.78613 20.6735C8.06953 20.748 8.36073 20.8 8.66666 20.8C10.5803 20.8 12.1333 19.2469 12.1333 17.3333Z"
        fill="#BE1931"
      />
      <path
        d="M11.2667 10.4C13.1813 10.4 14.7333 8.84791 14.7333 6.93333C14.7333 5.01874 13.1813 3.46666 11.2667 3.46666C9.35208 3.46666 7.8 5.01874 7.8 6.93333C7.8 8.84791 9.35208 10.4 11.2667 10.4Z"
        fill="#BE1931"
      />
      <path
        d="M19.0667 7.79999C17.1531 7.79999 15.6 9.35219 15.6 11.2667C15.6 13.1811 17.1531 14.7333 19.0667 14.7333C19.6577 14.7333 20.2063 14.5713 20.6934 14.3104L22.3314 10.1452C21.8634 8.78365 20.5851 7.79999 19.0667 7.79999ZM13.8667 21.6667C13.8667 23.2856 14.9829 24.635 16.4831 25.0155L18.9904 18.6394C18.4964 18.3681 17.9374 18.2 17.3333 18.2C15.4197 18.2 13.8667 19.7531 13.8667 21.6667ZM6.06666 10.4C6.06666 8.48552 4.51446 6.93332 2.6 6.93332C2.5246 6.93332 2.45353 6.95065 2.379 6.95585C2.85566 8.17959 3.744 10.4364 4.784 13.0719C5.56053 12.4358 6.06666 11.4816 6.06666 10.4Z"
        fill="#BE1931"
      />
    </svg>
  );
};

export default PizzaEmoji;
